/* Everest VW "Build your upgrade" funnel (Get You Booked, Oct 2026). Pairs with sections/ev-van-funnel.liquid.
   Step 1 van (reg lookup or pick), step 2 DigiDash, step 3 DUDU7. A yes to the DUDU7 opens the builder on the page
   (assets/ev-dudu7-builder.js) through window.EVB, and the DigiDash rides along in window.EVB_EXTRA. */
(function () {
  'use strict';

  var root = document.querySelector('[data-evf]');
  if (!root) return;
  var CFG;
  try { CFG = JSON.parse(root.querySelector('[data-evf-config]').textContent); } catch (e) { return; }
  var VANS = CFG.vehicles || [];

  // Impossible plates (I and Q are never issued) for previewing the lookup before the DVSA keys arrive.
  var DEMO = {
    TR12VIQ: { make: 'VOLKSWAGEN', model: 'TRANSPORTER T28 TDI', year: 2012, colour: 'Blue', fuel: 'Diesel' },
    TR19VIQ: { make: 'VOLKSWAGEN', model: 'TRANSPORTER T28 HIGHLINE TDI', year: 2019, colour: 'White', fuel: 'Diesel' },
    TR21VIQ: { make: 'VOLKSWAGEN', model: 'TRANSPORTER T30 TDI', year: 2021, colour: 'Grey', fuel: 'Diesel' },
    CR20VIQ: { make: 'VOLKSWAGEN', model: 'CRAFTER CR35 TRENDLINE TDI', year: 2020, colour: 'White', fuel: 'Diesel' },
    CA17VIQ: { make: 'VOLKSWAGEN', model: 'CADDY C20 TDI', year: 2017, colour: 'Red', fuel: 'Diesel' }
  };

  var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  function money(p) { return fmt.format((p || 0) / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function vanById(id) { for (var i = 0; i < VANS.length; i++) if (VANS[i].id === id) return VANS[i]; return null; }
  function smooth() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }

  var state = { open: 1, done: {}, van: null, dash: '', d7: '', reg: '', regInfo: null, busy: false };

  // ---------- DigiDash variants ----------
  function isFitted(v) { return /fit/i.test(v.title); }
  function variantLabel(v) { return isFitted(v) ? 'Supplied and fitted' : 'Supply only'; }
  function variantSub(v) { return isFitted(v) ? 'Fitted by Antony in St Neots or Welford, or at your address' : 'Delivered to you, with fitting guides and phone support'; }
  function dashVariant() {
    if (!state.van || !state.van.product || !state.dash || state.dash === 'none') return null;
    var vs = state.van.product.variants;
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === state.dash) return vs[i];
    return null;
  }

  // ---------- registration ----------
  function cleanReg(r) { return String(r || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function yearOf(info) {
    if (info.year) return +info.year;
    var d = info.manufactureYear || info.manufactureDate || info.firstUsedDate || info.registrationDate || '';
    var m = String(d).match(/(19|20)\d{2}/);
    return m ? +m[0] : 0;
  }
  // Which of our van codes a make, model and year could be. More than one means we ask.
  function codesFor(info) {
    var make = String(info.make || '').toUpperCase();
    var model = String(info.model || '').toUpperCase();
    var y = yearOf(info);
    if (/MAN/.test(make) && /TGE/.test(model)) return y >= 2017 ? ['CRA'] : [];
    if (!/VOLKSWAGEN|^VW/.test(make)) return [];
    if (/CRAFTER/.test(model)) return y >= 2017 ? ['CRA'] : [];
    if (/CADDY/.test(model)) {
      if (y >= 2004 && y <= 2009) return ['CAD1'];
      if (y === 2010) return ['CAD1', 'CAD2'];
      if (y >= 2011 && y <= 2014) return ['CAD2'];
      if (y === 2015) return ['CAD2', 'CAD3'];
      if (y >= 2016 && y <= 2020) return ['CAD3'];
      return [];
    }
    if (/TRANSPORTER|CARAVELLE|CALIFORNIA|MULTIVAN|SHUTTLE|KOMBI|\bT2[68]\b|\bT3[02]\b/.test(model)) {
      if (y >= 2003 && y <= 2009) return ['T5'];
      if (y >= 2010 && y <= 2014) return ['T51'];
      if (y === 2015) return ['T51', 'T6'];
      if (y >= 2016 && y <= 2018) return ['T6'];
      if (y === 2019) return ['T6', 'T61'];
      if (y >= 2020 && y <= 2024) return ['T61'];
      return [];
    }
    return [];
  }
  function lookup(reg) {
    if (CFG.regEndpoint) {
      var url = CFG.regEndpoint + (CFG.regEndpoint.indexOf('?') < 0 ? '?' : '&') + 'reg=' + encodeURIComponent(reg);
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (r.status === 404) return { notFound: true };
        if (!r.ok) throw new Error('lookup');
        return r.json();
      });
    }
    if (CFG.regDemo && DEMO[reg]) return new Promise(function (res) { setTimeout(function () { res(DEMO[reg]); }, 450); });
    return Promise.resolve({ unavailable: true });
  }
  function regMsg(html, tone) {
    var m = $('[data-evf-reg-msg]');
    if (!m) return;
    m.innerHTML = html;
    m.className = 'evf-reg__msg' + (tone ? ' is-' + tone : '');
  }
  function showVans(highlight) {
    var box = $('[data-evf-vans]');
    box.hidden = false;
    var btn = $('[data-evf-manual]');
    if (btn) { btn.hidden = true; btn.setAttribute('aria-expanded', 'true'); }
    $$('[data-evf-van]').forEach(function (b) {
      var v = vanById(b.getAttribute('data-evf-van'));
      b.classList.toggle('is-maybe', !!highlight && !!v && highlight.indexOf(v.code) >= 0);
    });
  }
  function onReg(e) {
    e.preventDefault();
    var input = $('[data-evf-reg-input]');
    var reg = cleanReg(input.value);
    if (reg.length < 2 || reg.length > 8) { regMsg('Please enter your registration, for example AB12 CDE.', 'warn'); input.focus(); return; }
    var btn = $('[data-evf-reg-btn]');
    btn.disabled = true; btn.textContent = 'Finding your van';
    regMsg('');
    lookup(reg).then(function (info) {
      btn.disabled = false; btn.textContent = 'Find my van';
      if (info.unavailable) {
        regMsg("We can't check registrations online just yet. Please pick your van below.", 'warn');
        showVans(); return;
      }
      if (info.notFound || !info.make) {
        regMsg("We couldn't find " + esc(reg) + '. Check the registration, or pick your van below.', 'warn');
        showVans(); return;
      }
      state.reg = reg; state.regInfo = info;
      var y = yearOf(info);
      var name = (y ? y + ' ' : '') + titleCase(info.make) + ' ' + titleCase(info.model);
      var extra = [info.colour || info.primaryColour, info.fuel || info.fuelType].filter(Boolean).map(titleCase).join(', ');
      var codes = codesFor(info);
      var matches = VANS.filter(function (v) { return v.code && codes.indexOf(v.code) >= 0; });
      var found = '<span class="evf-found"><b>' + esc(name) + '</b>' + (extra ? '<small>' + esc(extra) + '</small>' : '') + '</span>';
      if (matches.length === 1) {
        regMsg(found + '<span class="evf-found__ok">Great, this fits your van.</span>', 'good');
        pickVan(matches[0], true);
      } else if (matches.length > 1) {
        regMsg(found + '<span>That year could be either model. Pick the one that matches yours below.</span>', 'good');
        showVans(codes);
      } else {
        regMsg(found + "<span>We don't have a kit listed for this one online. Call us on <a href=\"tel:" + esc(CFG.phone.replace(/\s/g, '')) + '">' + esc(CFG.phone) + '</a> and we\'ll check, or <a href="' + esc(CFG.collectionUrl) + '">see all digital dashboards</a>.</span>', 'warn');
        showVans();
      }
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Find my van';
      regMsg("Sorry, the lookup isn't working right now. Please pick your van below.", 'warn');
      showVans();
    });
  }
  function titleCase(s) {
    return String(s || '').toLowerCase().replace(/\b([a-z])/g, function (c) { return c.toUpperCase(); })
      .replace(/\bTdi\b/g, 'TDI').replace(/\bVw\b/g, 'VW').replace(/\b(T\d{1,2}|C\d{2}|Cr\d{2})\b/gi, function (m) { return m.toUpperCase(); });
  }

  // ---------- steps ----------
  function pickVan(v, fromReg) {
    var changed = !state.van || state.van.id !== v.id;
    // A van picked by hand that the looked-up reg can't be loses the reg, so the order isn't tagged wrongly.
    if (!fromReg && state.regInfo && codesFor(state.regInfo).indexOf(v.code) < 0) {
      state.reg = ''; state.regInfo = null; regMsg('');
      var ri = $('[data-evf-reg-input]'); if (ri) ri.value = '';
    }
    state.van = v;
    if (changed) { state.dash = ''; }
    $$('[data-evf-van]').forEach(function (b) {
      var on = b.getAttribute('data-evf-van') === v.id;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    renderDash();
    state.done[1] = true;
    if (state.d7 === 'yes') openBuilder();
    syncCarry();
    openStep(2, fromReg ? 900 : 0);
  }
  function renderDash() {
    var v = state.van, p = v && v.product;
    var box = $('[data-evf-dash]'), opts = $('[data-evf-dash-opts]'), pts = $('[data-evf-points]');
    if (!p) {
      box.innerHTML = '<p class="evf-note">We don\'t list a DigiDash for the ' + esc(v ? v.name : 'this van') + ' online yet. Call us on ' + esc(CFG.phone) + ' to ask.</p>';
      opts.innerHTML = choice('none', '<b>Skip the dashboard</b>', '', true);
      state.dash = 'none';
      if (pts) pts.hidden = true;
      render(); return;
    }
    var lo = p.variants.reduce(function (m, x) { return m === null || x.price < m.price ? x : m; }, null);
    box.innerHTML =
      '<div class="evf-dash__card">' +
        (p.image ? '<img class="evf-dash__img" src="' + esc(p.image) + '" width="320" height="320" alt="" loading="lazy">' : '') +
        '<div class="evf-dash__text">' +
          '<p class="evf-dash__kicker">Fits your ' + esc(v.name) + (v.years ? ' (' + esc(v.years) + ')' : '') + '</p>' +
          '<p class="evf-dash__title">' + esc(p.title.replace(/ Digital Dashboard Upgrade/i, '') + ' DigiDash') + '</p>' +
          '<p class="evf-dash__price">From <b>' + money(lo.price) + '</b>' + (lo.compareAt > lo.price ? ' <s>' + money(lo.compareAt) + '</s>' : '') + '</p>' +
          '<a class="evf-link" href="' + esc(p.url) + '" target="_blank" rel="noopener">Full details and photos</a>' +
        '</div>' +
      '</div>';
    if (pts) pts.hidden = false;
    opts.innerHTML = p.variants.map(function (x) {
      var pr = '<span class="evf-choice__price"><b>' + money(x.price) + '</b>' + (x.compareAt > x.price ? '<s>' + money(x.compareAt) + '</s>' : '') + '</span>';
      return choice(String(x.id), '<b>Yes, ' + esc(variantLabel(x).toLowerCase()) + '</b><small>' + esc(variantSub(x)) + '</small>', pr, String(x.id) === state.dash);
    }).join('') + choice('none', '<b>No thanks</b><small>I already have one, or just want the head unit</small>', '', state.dash === 'none');
    render();
  }
  function choice(val, label, priceHtml, checked) {
    return '<label class="evf-choice"><input type="radio" name="evf-dash" value="' + esc(val) + '"' + (checked ? ' checked' : '') + '>' +
      '<span class="evf-choice__card"><span class="evf-choice__radio" aria-hidden="true"></span><span class="evf-choice__name">' + label + '</span>' + (priceHtml || '') + '</span></label>';
  }

  function openStep(n, delay) {
    for (var i = 1; i < n; i++) if (!stepOk(i)) { n = i; break; }
    state.open = n;
    render();
    var go = function () {
      var el = $('[data-evf-step="' + n + '"]');
      if (el && el.getBoundingClientRect().top < 60 || el && el.getBoundingClientRect().top > window.innerHeight * 0.6) el.scrollIntoView({ behavior: smooth(), block: 'start' });
    };
    if (delay) setTimeout(go, delay); else go();
  }
  function stepOk(n) {
    if (n === 1) return !!state.van;
    if (n === 2) return !!state.dash;
    return true;
  }

  // ---------- DUDU7 builder hand-off ----------
  function dashLine() {
    var dv = dashVariant();
    if (!dv) return null;
    return { title: 'DigiDash for your ' + state.van.name, sub: variantLabel(dv), price: dv.price, id: dv.id };
  }
  function syncCarry() {
    var l = dashLine();
    var props = { Vehicle: state.van ? state.van.name : '' };
    if (state.reg) props.Registration = state.reg;
    window.EVB_EXTRA = l ? {
      lines: [{ title: l.title, sub: l.sub, price: l.price }],
      items: [{ id: l.id, quantity: 1, properties: props }],
      reg: state.reg
    } : { lines: [], items: [], reg: state.reg };
    var carry = $('[data-evf-carry]');
    carry.innerHTML = l ? '<span>Included with your build: <b>' + esc(l.title) + '</b>, ' + esc(l.sub.toLowerCase()) + ', ' + money(l.price) + '</span><button type="button" class="evf-step__edit" data-evf-edit="2">Change</button>' : '';
    carry.hidden = !(l && state.d7 === 'yes');
    if (window.EVB && typeof window.EVB.refresh === 'function') window.EVB.refresh();
  }
  function whenBuilder(cb, tries) {
    if (window.EVB && window.EVB.setVehicle) { cb(window.EVB); return; }
    if ((tries || 0) > 40) return;
    setTimeout(function () { whenBuilder(cb, (tries || 0) + 1); }, 100);
  }
  function openBuilder() {
    $('[data-evf-builder]').hidden = false;
    whenBuilder(function (B) {
      B.setVehicle(state.van.dudu, state.reg);
      var br = document.querySelector('[data-evb="dudu7"] [data-reg]');
      if (br && !state.reg && br.value) { br.value = ''; br.dispatchEvent(new Event('input', { bubbles: true })); }
    });
  }

  // ---------- render ----------
  function render() {
    for (var i = 1; i <= 2; i++) if (!stepOk(i)) { for (var j = i; j <= 3; j++) delete state.done[j]; if (state.open > i) state.open = i; break; }
    $$('[data-evf-step]').forEach(function (el) {
      var n = +el.getAttribute('data-evf-step');
      el.classList.toggle('is-open', n === state.open);
      el.classList.toggle('is-done', !!state.done[n] && n !== state.open);
      el.classList.toggle('is-locked', n > state.open && !state.done[n] && !(n === 3 && state.done[2]));
    });
    $$('[data-evf-dot]').forEach(function (d) {
      var n = +d.getAttribute('data-evf-dot');
      d.classList.toggle('is-open', n === state.open);
      d.classList.toggle('is-done', !!state.done[n] && n !== state.open);
    });
    var dv = dashVariant();
    sum(1, state.van ? state.van.name + (state.reg ? ' (' + state.reg + ')' : '') : '');
    sum(2, state.dash ? (dv ? 'DigiDash, ' + variantLabel(dv).toLowerCase() + ', ' + money(dv.price) : 'No dashboard') : '');
    sum(3, state.d7 === 'yes' ? 'Building your DUDU7' : (state.d7 === 'no' ? 'No head unit' : ''));
    $('[data-evf-next="2"]').disabled = !state.dash;

    $$('[data-evf-d7]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-evf-d7') === state.d7 ? 'true' : 'false'); });
    var noSub = $('[data-evf-no-sub]');
    if (noSub) noSub.textContent = dv ? 'Just the dashboard' : 'Not this time';
    var onlyDash = state.d7 === 'no' && !!dv;
    $('[data-evf-only]').hidden = !onlyDash;
    $('[data-evf-none]').hidden = !(state.d7 === 'no' && !dv);
    if (state.d7 !== 'yes') $('[data-evf-builder]').hidden = true;
    if (onlyDash) {
      $('[data-evf-only-lines]').innerHTML = '<li><span>' + esc(dashLine().title) + '<small>' + esc(variantLabel(dv)) + '</small></span><b>' + money(dv.price) + '</b></li>';
      $('[data-evf-only-total]').textContent = money(dv.price);
      var add = $('[data-evf-add]');
      add.disabled = state.busy;
      add.textContent = state.busy ? 'Adding' : 'Add to basket';
    }
  }
  function sum(n, text) { var el = $('[data-evf-sum="' + n + '"]'); if (el) el.textContent = (state.done[n] || (n === 3 && state.d7)) ? text : ''; }

  // ---------- basket (dashboard only) ----------
  function addDashOnly() {
    var l = dashLine();
    if (!l || state.busy) return;
    var props = { Vehicle: state.van.name };
    if (state.reg) props.Registration = state.reg;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: l.id, quantity: 1, properties: props }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    state.busy = true; render();
    var err = $('[data-evf-err]'); err.hidden = true;
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        state.busy = false; render();
        if (!res.ok || res.j.status) { err.textContent = (res.j && (res.j.description || res.j.message)) || 'Something went wrong. Please try again or call us.'; err.hidden = false; return; }
        if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(Object.assign({ id: l.id }, res.j));
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'evf', productVariantId: l.id, cartData: res.j }); } catch (e) {}
        }
      })
      .catch(function () { state.busy = false; render(); err.textContent = 'We couldn’t reach the basket. Check your connection and try again.'; err.hidden = false; });
  }

  // ---------- events ----------
  var regForm = $('[data-evf-reg]');
  if (regForm) {
    regForm.addEventListener('submit', onReg);
    var regInput = $('[data-evf-reg-input]');
    regInput.addEventListener('input', function () {
      var c = cleanReg(regInput.value);
      // Show it the way it looks on a plate: AB12 CDE.
      regInput.value = /^[A-Z]{2}\d{2}[A-Z]{0,3}$/.test(c) && c.length > 4 ? c.slice(0, 4) + ' ' + c.slice(4) : c;
    });
  }
  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-evf-manual]'))) { showVans(); var first = $('[data-evf-van]'); if (first) first.focus(); return; }
    if ((t = e.target.closest('[data-evf-van]'))) { var v = vanById(t.getAttribute('data-evf-van')); if (v) pickVan(v, false); return; }
    if ((t = e.target.closest('[data-evf-edit]'))) { openStep(+t.getAttribute('data-evf-edit')); return; }
    if ((t = e.target.closest('[data-evf-next]'))) {
      if (t.disabled) return;
      var n = +t.getAttribute('data-evf-next'); state.done[n] = true; openStep(n + 1); return;
    }
    if ((t = e.target.closest('[data-evf-d7]'))) {
      state.d7 = t.getAttribute('data-evf-d7');
      state.done[3] = true;
      syncCarry();
      if (state.d7 === 'yes') {
        openBuilder();
        render();
        setTimeout(function () { var b = document.getElementById('build'); if (b) b.scrollIntoView({ behavior: smooth(), block: 'start' }); }, 120);
      } else { render(); }
      return;
    }
    if (e.target.closest('[data-evf-add]')) addDashOnly();
  });
  root.addEventListener('change', function (e) {
    if (e.target.name === 'evf-dash') {
      state.dash = e.target.value;
      syncCarry();
      render();
    }
  });

  syncCarry();
  render();
})();
